module.exports = __webpack_public_path__ + "ac43711a3d21a1ad4b2b3d50c1ffbc5c.png";